export const simpleStorageAbi = [
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "_to",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "AseetTransferred",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetCondition",
        "type": "string"
      }
    ],
    "name": "AssetConditionChanged",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetID",
        "type": "string"
      },
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetDetails",
        "type": "string"
      }
    ],
    "name": "AssetDetailsChanged",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "indexed": true,
        "internalType": "uint8",
        "name": "_assetGrade",
        "type": "uint8"
      }
    ],
    "name": "AssetGradeChanged",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetManufacturer",
        "type": "string"
      }
    ],
    "name": "AssetManufacturerChanged",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "indexed": true,
        "internalType": "string",
        "name": "_manufacturingYear",
        "type": "string"
      }
    ],
    "name": "AssetManufacturingYearChanged",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetName",
        "type": "string"
      }
    ],
    "name": "AssetNameChanged",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetSet",
        "type": "string"
      }
    ],
    "name": "AssetSetChanged",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "_to",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "_lastPrice",
        "type": "uint256"
      }
    ],
    "name": "AssetTransferred",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "_toAdd",
        "type": "address"
      }
    ],
    "name": "AuthorityAdded",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "_toRemove",
        "type": "address"
      }
    ],
    "name": "AuthorityRemoved",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "BlacklistedAsset",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "indexed": true,
        "internalType": "string",
        "name": "_cardNumber",
        "type": "string"
      }
    ],
    "name": "CardNumberChanged",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint8",
        "name": "_assetGrade",
        "type": "uint8"
      },
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "NewAssetRegistered",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "_newHotOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "_newColdOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "_oldColdOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "RemovedAssetFromBlacklist",
    "type": "event"
  },
  {
    "constant": false,
    "inputs": [
      {
        "internalType": "address",
        "name": "_toAdd",
        "type": "address"
      }
    ],
    "name": "addAuthorized",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [],
    "name": "coldOwner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [],
    "name": "hotOwner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "internalType": "address",
        "name": "_authorized",
        "type": "address"
      }
    ],
    "name": "isAuthorized",
    "outputs": [
      {
        "internalType": "bool",
        "name": "_isauthorized",
        "type": "bool"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "internalType": "address",
        "name": "_toRemove",
        "type": "address"
      }
    ],
    "name": "removeAuthorized",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "internalType": "address",
        "name": "_newHotOwner",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "_newColdOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_manufacturingYear",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_assetManufacturer",
        "type": "string"
      },
      {
        "internalType": "uint8",
        "name": "_assetGrade",
        "type": "uint8"
      },
      {
        "internalType": "string",
        "name": "_assetName",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_assetCondition",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_cardNumber",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_set",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_assetDetails",
        "type": "string"
      }
    ],
    "name": "registerNewAsset",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "blacklistAsset",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "removeAssetFromBlacklist",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "internalType": "address",
        "name": "_to",
        "type": "address"
      },
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "internalType": "uint256",
        "name": "_lastPrice",
        "type": "uint256"
      }
    ],
    "name": "transferAsset",
    "outputs": [
      {
        "internalType": "bool",
        "name": "success",
        "type": "bool"
      }
    ],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_assetName",
        "type": "string"
      }
    ],
    "name": "changeAssetName",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_assetCondition",
        "type": "string"
      }
    ],
    "name": "changeAssetCondition",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "internalType": "uint8",
        "name": "_assetGrade",
        "type": "uint8"
      }
    ],
    "name": "changeAssetGrade",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_assetManufacturingYear",
        "type": "string"
      }
    ],
    "name": "changeAssetManufacturingYear",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_assetSet",
        "type": "string"
      }
    ],
    "name": "changeAssetSet",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_cardNumber",
        "type": "string"
      }
    ],
    "name": "changeCardNumber",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_assetDetails",
        "type": "string"
      }
    ],
    "name": "changeAssetDetails",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_assetManufacturer",
        "type": "string"
      }
    ],
    "name": "changeAssetManufacturer",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "getAssetGrade",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "_assetGrade",
        "type": "uint8"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "getAssetOwner",
    "outputs": [
      {
        "internalType": "address",
        "name": "_assetOwner",
        "type": "address"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "getAssetName",
    "outputs": [
      {
        "internalType": "string",
        "name": "_assetName",
        "type": "string"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "getAssetCondition",
    "outputs": [
      {
        "internalType": "string",
        "name": "_assetCondition",
        "type": "string"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "getAssetManufacturingYear",
    "outputs": [
      {
        "internalType": "string",
        "name": "_assetManufacturingYear",
        "type": "string"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "getAssetManufacturer",
    "outputs": [
      {
        "internalType": "string",
        "name": "_assetManufacturer",
        "type": "string"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "getAssetSet",
    "outputs": [
      {
        "internalType": "string",
        "name": "_assetSet",
        "type": "string"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "getCardNumber",
    "outputs": [
      {
        "internalType": "string",
        "name": "_cardNumber",
        "type": "string"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "getAssetDetails",
    "outputs": [
      {
        "internalType": "string",
        "name": "_assetDetails",
        "type": "string"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "isBlacklisted",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "internalType": "string",
        "name": "_assetId",
        "type": "string"
      }
    ],
    "name": "isAssetRegistered",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "payable": false,
    "stateMutability": "view",
    "type": "function"
  }
]